@if (positionAndWeatherStore.speedAndDistance()) {
  <form
    #form="ngForm"
    novalidate
    class="flex flex-col gap-1"
  >
    @let vm = offshoreReportStore.vm();
    <nsp-number-input
      *nspVisible="vm.isFieldVisible(tabId, sectionId, 'tripCounterGps')"
      name="tripCounterGps"
      id="tripCounterGps"
      label="Trip Counter GPS"
      [unit]="units.nauticalMiles"
      [labelWidthPercentage]="33"
      [required]="vm.isFieldRequired(tabId, sectionId, 'tripCounterGps')"
      [readonly]="vm.isFieldReadOnly(tabId, sectionId, 'tripCounterGps')"
      [min]="0"
      [value]="positionAndWeatherStore.speedAndDistance().tripCounterGps.value"
      [ngModel]="
        positionAndWeatherStore.speedAndDistance().tripCounterGps.value
      "
    />
    <nsp-number-input
      *nspVisible="vm.isFieldVisible(tabId, sectionId, 'tripCounterLog')"
      name="tripCounterLog"
      id="tripCounterLog"
      label="Trip Counter Log"
      [unit]="units.nauticalMiles"
      [labelWidthPercentage]="33"
      [required]="vm.isFieldRequired(tabId, sectionId, 'tripCounterLog')"
      [readonly]="vm.isFieldReadOnly(tabId, sectionId, 'tripCounterLog')"
      [min]="0"
      [value]="positionAndWeatherStore.speedAndDistance().tripCounterLog.value"
      [ngModel]="
        positionAndWeatherStore.speedAndDistance().tripCounterLog.value
      "
    />
    <nsp-checkbox-input
      *nspVisible="vm.isFieldVisible(tabId, sectionId, 'speedLogMalfunction')"
      class="h-10.5 place-content-center"
      name="speedLogMalfunction"
      id="speedLogMalfunction"
      label="Speed Log Malfunction"
      [labelWidthPercentage]="33"
      [required]="vm.isFieldRequired(tabId, sectionId, 'speedLogMalfunction')"
      [readonly]="vm.isFieldReadOnly(tabId, sectionId, 'speedLogMalfunction')"
      [value]="
        positionAndWeatherStore.speedAndDistance().speedLogMalfunction.value
      "
      [ngModel]="
        positionAndWeatherStore.speedAndDistance().speedLogMalfunction.value
      "
    />
    <nsp-number-input
      *nspVisible="vm.isFieldVisible(tabId, sectionId, 'logSpeed')"
      name="logSpeed"
      id="logSpeed"
      label="Log Speed"
      [unit]="'Knots'"
      [labelWidthPercentage]="33"
      [required]="!positionAndWeatherStore.vm().isSpeedLogMalfunction"
      [min]="0"
      [value]="positionAndWeatherStore.speedAndDistance().logSpeed.value"
      [ngModel]="positionAndWeatherStore.speedAndDistance().logSpeed.value"
    />
    <nsp-number-input
      *nspVisible="vm.isFieldVisible(tabId, sectionId, 'logDistance')"
      name="logDistance"
      id="logDistance"
      label="Log Distance"
      [unit]="units.nauticalMiles"
      [labelWidthPercentage]="33"
      [required]="!positionAndWeatherStore.vm().isSpeedLogMalfunction"
      [min]="0"
      [value]="positionAndWeatherStore.speedAndDistance().logDistance.value"
      [ngModel]="positionAndWeatherStore.speedAndDistance().logDistance.value"
    />
    <nsp-number-input
      *nspVisible="vm.isFieldVisible(tabId, sectionId, 'courseOverGround')"
      name="courseOverGround"
      id="courseOverGround"
      label="Course Over Ground (COG)"
      [unit]="units.degrees"
      [labelWidthPercentage]="33"
      [required]="vm.isFieldRequired(tabId, sectionId, 'courseOverGround')"
      [readonly]="vm.isFieldReadOnly(tabId, sectionId, 'courseOverGround')"
      [min]="0"
      [value]="
        positionAndWeatherStore.speedAndDistance().courseOverGround.value
      "
      [ngModel]="
        positionAndWeatherStore.speedAndDistance().courseOverGround.value
      "
    />
    <nsp-number-input
      *nspVisible="vm.isFieldVisible(tabId, sectionId, 'observedSpeed')"
      name="observedSpeed"
      id="observedSpeed"
      label="Observed Speed"
      [unit]="'Knots'"
      [labelWidthPercentage]="33"
      [required]="vm.isFieldRequired(tabId, sectionId, 'observedSpeed')"
      [readonly]="vm.isFieldReadOnly(tabId, sectionId, 'observedSpeed')"
      [min]="0"
      [value]="positionAndWeatherStore.speedAndDistance().observedSpeed.value"
      [ngModel]="positionAndWeatherStore.speedAndDistance().observedSpeed.value"
    />
    <nsp-number-input
      *nspVisible="vm.isFieldVisible(tabId, sectionId, 'observedDistance')"
      name="observedDistance"
      id="observedDistance"
      label="Observed Distance"
      [unit]="units.nauticalMiles"
      [labelWidthPercentage]="33"
      [required]="vm.isFieldRequired(tabId, sectionId, 'observedDistance')"
      [readonly]="vm.isFieldReadOnly(tabId, sectionId, 'observedDistance')"
      [min]="0"
      [value]="
        positionAndWeatherStore.speedAndDistance().observedDistance.value
      "
      [ngModel]="
        positionAndWeatherStore.speedAndDistance().observedDistance.value
      "
    />
    <nsp-number-input
      *nspVisible="vm.isFieldVisible(tabId, sectionId, 'observedDistanceInEca')"
      name="observedDistanceInEca"
      id="observedDistanceInEca"
      label="Observed Distance In ECA"
      [unit]="units.nauticalMiles"
      [labelWidthPercentage]="33"
      [required]="vm.isFieldRequired(tabId, sectionId, 'observedDistanceInEca')"
      [readonly]="vm.isFieldReadOnly(tabId, sectionId, 'observedDistanceInEca')"
      [min]="0"
      [value]="
        positionAndWeatherStore.speedAndDistance().observedDistanceInEca.value
      "
      [ngModel]="
        positionAndWeatherStore.speedAndDistance().observedDistanceInEca.value
      "
    />
    <nsp-number-input
      *nspVisible="
        vm.isFieldVisible(tabId, sectionId, 'observedDistanceTotalSeaPassage')
      "
      name="observedDistanceTotalSeaPassage"
      id="observedDistanceTotalSeaPassage"
      label="Observed Distance for Total Sea Passage"
      [unit]="units.nauticalMiles"
      [labelWidthPercentage]="33"
      [required]="
        vm.isFieldRequired(tabId, sectionId, 'observedDistanceTotalSeaPassage')
      "
      [readonly]="
        vm.isFieldReadOnly(tabId, sectionId, 'observedDistanceTotalSeaPassage')
      "
      [min]="0"
      [value]="
        positionAndWeatherStore.speedAndDistance()
          .observedDistanceTotalSeaPassage.value
      "
      [ngModel]="
        positionAndWeatherStore.speedAndDistance()
          .observedDistanceTotalSeaPassage.value
      "
    />
    <nsp-number-input
      *nspVisible="vm.isFieldVisible(tabId, sectionId, 'remainingDistance')"
      name="remainingDistance"
      id="remainingDistance"
      label="Remaining Distance"
      [unit]="units.nauticalMiles"
      [labelWidthPercentage]="33"
      [required]="vm.isFieldRequired(tabId, sectionId, 'remainingDistance')"
      [readonly]="vm.isFieldReadOnly(tabId, sectionId, 'remainingDistance')"
      [min]="0"
      [value]="
        positionAndWeatherStore.speedAndDistance().remainingDistance.value
      "
      [ngModel]="
        positionAndWeatherStore.speedAndDistance().remainingDistance.value
      "
    />
    <nsp-number-input
      *nspVisible="vm.isFieldVisible(tabId, sectionId, 'badWeatherHours')"
      name="badWeatherHours"
      id="badWeatherHours"
      label="Bad Weather Hours"
      [unit]="'Hours'"
      [labelWidthPercentage]="33"
      [required]="vm.isFieldRequired(tabId, sectionId, 'badWeatherHours')"
      [readonly]="vm.isFieldReadOnly(tabId, sectionId, 'badWeatherHours')"
      [min]="0"
      [value]="positionAndWeatherStore.speedAndDistance().badWeatherHours.value"
      [ngModel]="
        positionAndWeatherStore.speedAndDistance().badWeatherHours.value
      "
    />
    <nsp-number-input
      *nspVisible="
        vm.isFieldVisible(tabId, sectionId, 'badWeatherObservedDistance')
      "
      name="badWeatherObservedDistance"
      id="badWeatherObservedDistance"
      label="Bad Weather Observed Distance"
      [unit]="units.nauticalMiles"
      [labelWidthPercentage]="33"
      [required]="
        vm.isFieldRequired(tabId, sectionId, 'badWeatherObservedDistance')
      "
      [readonly]="
        vm.isFieldReadOnly(tabId, sectionId, 'badWeatherObservedDistance')
      "
      [min]="0"
      [value]="
        positionAndWeatherStore.speedAndDistance().badWeatherObservedDistance
          .value
      "
      [ngModel]="
        positionAndWeatherStore.speedAndDistance().badWeatherObservedDistance
          .value
      "
    />
  </form>
}
